import { render, staticRenderFns } from "./TevaSubMenu.vue?vue&type=template&id=52a21c4e&scoped=true&"
import script from "./TevaSubMenu.vue?vue&type=script&lang=js&"
export * from "./TevaSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./TevaSubMenu.vue?vue&type=style&index=0&id=52a21c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a21c4e",
  null
  
)

export default component.exports